{
	"app_sidebar": {
		"menu": {
			"theme": "Theme"
		},
		"theme": {
			"dark": "Dark",
			"light": "Light",
			"system": "System"
		},
		"user_menu": {
			"language": "Language",
			"language_no_results": "No languages found",
			"language_search_placeholder": "Search language..."
		}
	},
	"async_pickers": {
		"selected_count_one": "1 selected",
		"selected_count_other": "{{count}} selected"
	},
	"auth_error_alert": {
		"close": "Close"
	},
	"avatar": {
		"add_photo": "Add photo",
		"change_photo": "Change photo",
		"invalid_type": "Choose a JPEG, PNG, or WebP image.",
		"remove_photo": "Remove photo",
		"too_large": "Choose an image smaller than 5 MB.",
		"upload_error": "Couldn't upload the photo."
	},
	"data_table": {
		"column_menu": {
			"autosize_column": "Autosize this column",
			"clear_sort": "Clear sort",
			"hide_column": "Hide column",
			"no_pin": "No pin",
			"pin_column": "Pin column",
			"pin_left": "Pin left",
			"pin_right": "Pin right",
			"sort_asc": "Sort ascending",
			"sort_desc": "Sort descending",
			"trigger": "Column options for {{column}}"
		},
		"column_settings": {
			"drag_handle": "Reorder column",
			"no_results": "No columns match",
			"pin_column": "Pin {{column}}",
			"pin_left": "Pin left",
			"pin_right": "Pin right",
			"reset": "Reset",
			"search_placeholder": "Search columns...",
			"show_all": "Show all",
			"toggle_visibility": "Toggle {{column}}",
			"trigger": "Columns",
			"unpin": "Unpin"
		},
		"error": "Failed to load data",
		"loading_more": "Loading more...",
		"no_results": "No results",
		"pagination": {
			"go_to_page": "Go to page {{page}}",
			"more_pages": "More pages",
			"next": "Next",
			"previous": "Previous",
			"rows_per_page": "Rows per page"
		},
		"resize_column": "Resize column",
		"select_all": "Select all rows",
		"select_row": "Select row",
		"sort_by": "Sort by {{column}}"
	},
	"date_input": {
		"open_calendar": "Open calendar",
		"validation": {
			"disabled_date": "This date is not available",
			"invalid_date": "Please enter a valid date",
			"max_date": "Date must be on or before {{maxDate}}",
			"min_date": "Date must be on or after {{minDate}}",
			"range": "Date must be between {{minDate}} and {{maxDate}}"
		}
	},
	"date_picker": {
		"cancel": "Cancel",
		"description": "Pick a date from the calendar",
		"presets": {
			"last_7_days": "Last 7 days",
			"last_month": "Last month",
			"last_year": "Last year",
			"this_month": "This month",
			"this_week": "This week",
			"this_year": "This year"
		},
		"submit": "Submit",
		"title": "Select date"
	},
	"drop_zone": {
		"accepted_formats": "Accepted: {{formats}} · up to {{size}}",
		"drag_and_drop_files": "Drag and drop files here",
		"drop_files_here": "Drop files here"
	},
	"http_errors": {
		"account_disabled": "Account disabled, contact Unicasa support.",
		"account_locked": "Too many wrong passwords: the account is locked for 15 minutes.",
		"admin_forbidden": "You don't have permission to perform this admin action.",
		"admin_target_user_not_found": "The selected admin user could not be found.",
		"admin_user_already_deleted": "This admin user has already been deleted.",
		"asset_corrupted": "This file could not be processed. Upload it again.",
		"asset_mime_type_not_allowed": "This file type is not allowed.",
		"asset_not_found": "This file could not be found.",
		"asset_ownership_error": "You do not have access to this file.",
		"asset_size_too_large": "This file is too large.",
		"asset_storage_missing": "File storage is not available.",
		"auth_credentials_missing": "Sign in before continuing.",
		"auth_csrf_invalid": "Your session security token is invalid. Refresh and try again.",
		"auth_email_not_found": "No account with this email address could be found.",
		"auth_jwt_invalid": "Your sign-in session is invalid or has expired. Sign in again.",
		"auth_session_issue_failed": "We couldn't complete sign-in. Please try again.",
		"auth_token_invalid": "Your sign-in session is invalid or has expired. Start again.",
		"backoffice_admin_deleted": "This admin account has been deleted.",
		"backoffice_admin_not_found": "This admin account could not be found.",
		"backoffice_auth_credentials_missing": "Sign in as an admin before continuing.",
		"backoffice_change_password_otp_invalid": "The email code is invalid. Please try again.",
		"backoffice_change_password_otp_unavailable": "Email codes are not available for changing this admin password.",
		"backoffice_csrf_invalid": "Your admin session security token is invalid. Refresh and try again.",
		"backoffice_email_already_in_use": "An admin account with this email already exists.",
		"backoffice_email_change_token_invalid": "The admin email change session is invalid or has expired.",
		"backoffice_email_otp_token_invalid": "Your verification session has expired. Request a new code.",
		"backoffice_invalid_email_or_password": "The email or password is invalid.",
		"backoffice_invite_invalid": "This admin invitation is invalid or has expired.",
		"backoffice_jwt_invalid": "Your admin session is invalid or has expired. Sign in again.",
		"backoffice_new_email_same_as_current": "The new admin email matches the current email.",
		"backoffice_no_change_password_method_available": "No available method can change this admin password.",
		"backoffice_reset_password_session_missing": "The admin password reset session is missing.",
		"backoffice_reset_password_token_invalid": "The admin password reset token is invalid or expired.",
		"backoffice_self_edit_forbidden": "You cannot edit your own admin account here.",
		"backoffice_session_expired": "Your admin session has expired. Sign in again.",
		"backoffice_session_invalid": "Your admin session is no longer valid. Sign in again.",
		"backoffice_session_issue_failed": "We couldn't complete sign-in. Please try again.",
		"call_already_published": "The call is already published: the residence data can no longer change.",
		"call_data_changed": "The residence data changed after you checked it: the page was refreshed, check it again.",
		"call_dates_locked": "The call has already opened: its dates can no longer change.",
		"call_document_incomplete": "The call notice cannot be written yet: some data of the residence are missing (decree, sites, privacy contacts, PEC or dates). Complete them and try again.",
		"call_document_text_unsupported": "The call text holds characters the document cannot print ({{characters}}): correct the residence texts (for example use Latin letters).",
		"call_end_before_start": "The end day must come after the opening.",
		"call_not_closed": "The residence has a call that is not closed yet: the call of the next year opens when all its calls are closed.",
		"call_not_ready": "The call cannot be published yet: complete the steps that are missing.",
		"call_notice_changed": "The call notice text changed while it was being written: nothing was saved, try again.",
		"call_read_only": "This call is read only: the residence has a more recent call and the call of the year before can no longer be changed.",
		"call_rules_changed": "Newer call rules are now in force: the page was refreshed, check and try again.",
		"call_start_in_past": "The opening of the call cannot be in the past.",
		"credential_account_not_found": "The credential account could not be found.",
		"default": "Oops! Something went wrong.",
		"email_already_in_use": "An account with this email already exists.",
		"email_change_token_invalid": "The email change session is invalid or has expired.",
		"email_not_verified": "This email address is not verified.",
		"email_otp_token_invalid": "Your verification session has expired. Request a new code.",
		"email_password_disabled": "Email and password sign-in is disabled.",
		"email_password_sign_up_disabled": "Email and password sign-up is disabled.",
		"email_text_changed": "Another admin changed this text after you opened it: reload the page to see the latest version.",
		"export_not_found": "This export could not be found.",
		"export_too_large_for_sync": "This export is too large for direct download. Use auto or email when ready.",
		"failed_to_create_session": "The session could not be created.",
		"failed_to_create_user": "The user could not be created.",
		"invalid_code": "The code is invalid.",
		"invalid_delete_account_otp": "The account deletion code is invalid.",
		"invalid_email": "The email address is invalid.",
		"invalid_token": "The token is invalid or expired.",
		"invalid_two_factor_cookie": "The two-factor authentication cookie is invalid.",
		"mailbox_test_throttled": "A test was sent a moment ago, or five already went in the last hour: wait a few minutes and try again.",
		"mfa_not_enabled": "Two-factor authentication is not enabled for this account.",
		"new_email_same_as_current": "The new email matches the current email.",
		"otp_expired": "The code has expired. Ask for a new one.",
		"otp_has_expired": "The one-time password has expired. Request a new code.",
		"otp_invalid": "The code is not correct. Check your email and try again.",
		"otp_issuance_throttled": "Too many code requests. Please wait before requesting a new one.",
		"otp_locked": "Too many wrong codes: try again in 15 minutes.",
		"otp_not_enabled": "One-time passwords are not enabled.",
		"otp_rate_limited": "Too many codes requested. Try again later.",
		"password_check_busy": "The server is checking many passwords right now. Try again in a few seconds.",
		"password_too_long": "The password is too long.",
		"password_too_short": "The password is too short.",
		"pdf_render_unavailable": "The document service is busy. Try again in a moment.",
		"permission_denied": "Your account is signed in, but it doesn't have the permissions required to view this page.",
		"previous_year_accepting_applications": "The call of the year before still takes applications on the seats left. Stop those applications to publish the new call.",
		"residence_photo_in_use": "This photo is already in another residence: upload it again for this one.",
		"residence_photo_uploads_pending": "You have too many uploaded photos not yet added to a residence: add them or try again later.",
		"resolve_user_required": "A user must be resolved before continuing.",
		"resolved_user_invalid": "The resolved user is invalid.",
		"rules_missing_for_year": "The call rules for the next academic year are not released yet: the new call opens when they are.",
		"sending_anomaly_no_managers": "This residence has no active facility manager to notify.",
		"session_expired": "Your session has expired. Sign in again.",
		"session_invalid": "Your session is no longer valid. Sign in again.",
		"session_not_found": "This session could not be found.",
		"session_not_fresh": "Please reauthenticate before continuing.",
		"session_required": "A valid session is required.",
		"text_not_printable": "A text holds characters the document cannot print ({{characters}}): correct it, for example with Latin letters.",
		"too_many_attempts": "Too many sign-in attempts from this network. Try again in a few minutes.",
		"too_many_attempts_request_new_code": "Too many attempts. Request a new code.",
		"two_factor_not_enabled": "Two-factor authentication is not enabled.",
		"unauthorized": "You're not signed in. Please log in to continue.",
		"user_already_exists_use_another_email": "A user with this email already exists. Use another email address.",
		"user_banned": "This user account has been banned.",
		"user_deleted": "This user account has been deleted.",
		"user_not_found": "This user could not be found.",
		"validation_error": "Some of the information you entered is invalid."
	},
	"inline_filter_date": {
		"from": "From {{date}}",
		"to": "Until {{date}}"
	},
	"inline_filters": {
		"clear": "Clear filter",
		"clear_all": "Clear all"
	},
	"input_currency": {
		"empty": "No currency found",
		"search": "Search currency...",
		"select_currency": "Select currency",
		"validation": {
			"invalid_amount": "Please enter a valid amount"
		}
	},
	"input_password": {
		"hide": "Hide password",
		"show": "Show password"
	},
	"input_phone": {
		"empty": "No country found",
		"search": "Search country...",
		"select_country": "Select country",
		"validation": {
			"invalid_phone_number": "Please enter a valid phone number"
		}
	},
	"list_input_search": {
		"clear": "Clear search"
	},
	"otp_input": {
		"label": "6-digit code"
	},
	"query_breadcrumbs": {
		"error": "Error",
		"no_data": "Detail"
	},
	"residence_service_groups": {
		"comfort": "Comfort",
		"common": "Spaces",
		"food_security": "Meals and security",
		"mobility": "Sport and mobility",
		"study": "Study"
	},
	"residence_services": {
		"air_conditioning": "Air conditioning",
		"bed_linen": "Bed linen",
		"bike_parking": "Bike parking",
		"canteen": "Canteen",
		"cleaning": "Cleaning",
		"common_kitchen": "Kitchen",
		"common_room": "Lounge",
		"elevator": "Lift",
		"garden": "Garden",
		"gym": "Gym",
		"laundry": "Laundry",
		"library": "Library",
		"parking": "Parking",
		"private_bathroom": "Private bathroom",
		"security": "Security",
		"shuttle": "Shuttle",
		"sports_field": "Sports field",
		"study_room": "Study room",
		"vending": "Vending",
		"wifi": "Wi-Fi"
	},
	"validation": {
		"otp_length": "Code must be 6 digits."
	}
}
